import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogForm from "@/shared/ui/SogForm.vue";
import PersonDetails from "@/shared/model/personDetails";
import {ref, watch} from "vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import Person from "@/shared/model/person";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";

interface Props {
  person?: Person,
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'ExportFormulareEditComponent',
  props: {
    person: { default: undefined },
    details: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {


const _form = ref<InstanceType<typeof SogForm> | null>(null)

const props = __props

const _formulareZumVersand = ref<number>(0)
const _min = ref<number>(0)


function validate(): boolean {
  return _form.value?.validate() ?? false;
}

watch(props, () => {
  _formulareZumVersand.value = props.details?.getNumberValue(PersonDetailsId.ExportBlankCountToSend) ?? 0
  _min.value = props.details?.getNumberValue(PersonDetailsId.ExportBlankMinimumCount) ?? 0
}, {immediate: true})

function getDetails(): PersonDetails | undefined {
  if (!validate()) return undefined;
  const details = new PersonDetails(props?.details?.getValues());
  details.setNumberValue(PersonDetailsId.ExportBlankCountToSend, _formulareZumVersand.value)
  details.setNumberValue(PersonDetailsId.ExportBlankMinimumCount, _min.value)
  return details;
}

__expose({
  validate,
  getDetails
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form
  }, {
    default: _withCtx(() => [
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogNumericTextBox, {
            modelValue: _formulareZumVersand.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_formulareZumVersand).value = $event)),
            placeholder: "Formulare zum Versand",
            name: "formulareZumVersand",
            format: "N",
            min: 0
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogNumericTextBox, {
            modelValue: _min.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_min).value = $event)),
            placeholder: "Mindest Bestand",
            name: "min",
            format: "N",
            min: 0
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})